module.exports = __webpack_public_path__ + "28af06cfd4ca434a1adf04db3500a26a.MP3";